import React from 'react';
import {
  List,
  Datagrid,
  CardActions,
  CreateButton,
  SelectField,
  ShowButton,
} from 'react-admin';
import { getAdminLevel, ADMIN_LEVELS } from '../../authProvider';
import { ConfigTypeEnum } from '../../helpers/mappings';
const ConfigCardActions = ({
  basePath,
  data,
}) => {
  const adminLevel = getAdminLevel();
  return (
    <CardActions>
      { adminLevel && adminLevel !== ADMIN_LEVELS.READ_ONLY_ADMIN ?
        <CreateButton basePath={basePath} record={data} /> : undefined
        }
    </CardActions>
  );
};

export const JSONField = ({ record, source }) => (
  <div
    style={{
      fontFamily: 'monospace',
      background: '#eee',
      padding: '1em',
    }}
  >
    {JSON.stringify(record[source], null, 2)}
  </div>
);

export default props => (
  <List
    {...props}
    sort={{ field: 'name', order: 'ASC' }}
    title="Application Configurations"
    bulkActionButtons={false}
    actions={<ConfigCardActions />}
  >
    <Datagrid>
      <SelectField source="configType" choices={ConfigTypeEnum} label="Configuration Type" />
      <JSONField source="appConfig" label="Application Configuration " />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/Config/List.jsx